module.exports = __webpack_public_path__ + "static/media/SFP-BNB.1ccea455.svg";